module.exports = __webpack_public_path__ + "static/media/arrowDownIcon.5ff29486.svg";